<template>
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0">Departman Ayarları</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <router-link tag="li" to="/" class="breadcrumb-item"><a>Anasayfa</a></router-link>
              <li class="breadcrumb-item active">Departmanlar</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content-header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-header card-title">
                Departmanlar
                <button class="btn btn-primary btn-sm float-right" @click="resetModal"
                  v-if="auth.DepartmentSetting != null && auth.DepartmentSetting.isWrite">
                  <i class="fas fa-plus"> </i> Yeni Departman
                </button>
              </div>
              <div class="card-body table-responsive p-0">
                <div class="overlay-wrapper">
                  <div class="overlay" v-if="overlay">
                    <i class="fas fa-3x fa-spinner fa-spin"></i>
                  </div>
                  <table class="table table-striped projects">
                    <thead>
                      <tr>
                        <th style="width: 1%">#</th>
                        <th>Departman Adı</th>
                        <th style="width: 30%">Açıklama</th>

                        <th style="min-width: 250px"
                          v-if="auth.DepartmentSetting != null && auth.DepartmentSetting.isWrite"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in datatable" :key="item.id">
                        <td>#</td>
                        <td>
                          <a> {{ item.name }} </a>
                        </td>
                        <td>{{ item.description }}</td>

                        <td class="project-actions text-right"
                          v-if="auth.DepartmentSetting != null && auth.DepartmentSetting.isWrite">
                          <router-link tag="button" :to="'/departments/authority/' + item.id"
                            class="btn btn-outline-primary btn-sm" title="Yetkiler">
                            <i class="fas fa-folder"> </i>
                          </router-link>
                          <button class="btn btn-outline-info btn-sm" @click="getModal(item)" title="Düzenle">
                            <i class="fas fa-pencil-alt"> </i>
                          </button>
                          <button class="btn btn-outline-danger btn-sm" @click="del(item.id)" title="Kaydı Sil">
                            <i class="fas fa-trash"> </i>
                          </button>
                        </td>
                      </tr>

                      <tr>
                        <td v-if="datatable.length == 0" colspan="4" class="text-center">
                          Kayıt Bulunamadı
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="card-footer">
                <pagination v-model="page" :records="rows" :per-page="perPage" @paginate="pagination" />
              </div>
            </div>

            <!-- /.card -->
          </div>
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </div>
    <!-- /.content -->

    <!--Modal-->
    <div class="modal fade" id="modal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              Departman {{ department.id ? "Düzenleme" : "Ekleme" }}
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="onSubmit">
              <div class="form-group">
                <label>Departman Adı</label>
                <input @blur="$v.department.name.$touch()" v-model="$v.department.name.$model" type="text"
                  class="form-control" :class="{ 'is-invalid': $v.department.name.$error }"
                  placeholder="Departman adını giriniz" />
                <small v-if="
                  !$v.department.name.required && $v.department.name.$error
                " class="form-text text-danger">Bu alan zorunludur...</small>
              </div>
              <div class="form-group">
                <label>Açıklama</label>
                <textarea v-model="department.description" class="form-control" placeholder="Açıklama giriniz"></textarea>
              </div>
            </form>
          </div>

          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              İptal
            </button>
            <button type="button" class="btn btn-primary" @click="save()" :disabled="$v.department.$invalid">
              Kaydet
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
  <!-- /.content-wrapper -->
</template>
<script>
import {
  required,
  minLength,
  maxLength,
  sameAs,
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      auth: this.$store.getters.getModules,
      page: 1,
      perPage: 10,
      rows: 0,
      departments: [],
      overlay: false,
      datatable: [],
      department: {
        name: "",
        description: "",
      },
    };
  },
  validations: {
    department: {
      name: {
        required,
      },
    },
  },
  methods: {
    pagination(value) {
      var count = (value - 1) * this.perPage;
      this.datatable = this.departments.slice(count, count + this.perPage);
    },
    getDatas() {
      this.overlay = true;
      this.$http.get("Department/ListDepartments").then((response) => {
        this.departments = response.data;
        this.datatable = this.departments.slice(0, this.perPage);
        this.rows = this.departments.length;
        this.overlay = false;
      });
    },
    getModal(value) {
      this.department = value;

      $("#modal").modal();
    },
    resetModal() {
      this.department = {
        name: "",
        description: "",
      };
      this.$v.$reset();
      $("#modal").modal();
    },
    save() {
      let url = "Department/AddDepartment";
      if (this.department.id)
        url = "Department/EditDepartment/" + this.department.id;

      this.$http.post(url, this.department).then((response) => {
        toastr.success("Kayıt başarılı.");
        $("#modal").modal("hide");
        this.getDatas();
      });
    },

    del(id) {
      Swal.fire({
        title: "Kayıt kalıcı olarak silinecek! Onaylıyor musunuz?",
        showCancelButton: true,
        confirmButtonText: "Evet! Silinsin",
        cancelButtonText: "İptal",
        icon: "question",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          this.$http
            .get("Department/DeleteDepartment/" + id)
            .then((response) => {
              toastr.success("Kayıt başarıyla silindi.");
              this.getDatas();
            });
        }
      });
    },
  },

  created() {
    this.getDatas();
  },
  watch: {
    "$store.getters.getModules"() {
      this.auth = this.$store.getters.getModules;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Department/DepartmentList.vue